import React from 'react';
import { Modal } from 'antd';
import { MobileOutlined } from '@ant-design/icons';

/** 网页端卡片不可打开详情时，提示前往 APP。 */
export function showAppDetailTip() {
  Modal.info({
    icon: null,
    centered: true,
    width: 340,
    className: 'message-app-detail-tip-modal',
    okText: '知道了',
    okButtonProps: {
      className: 'message-app-detail-tip-ok',
    },
    content: (
      <div className="message-app-detail-tip">
        <div className="message-app-detail-tip-icon">
          <MobileOutlined />
        </div>
        <div className="message-app-detail-tip-title">请前往 APP 查看详情</div>
        <div className="message-app-detail-tip-desc">
          网页端暂不支持打开该内容，请在圆领 APP 中查看完整详情。
        </div>
      </div>
    ),
  });
}

interface AppDetailClickableProps {
  children: React.ReactNode;
  className?: string;
}

/** 包裹业务卡片，点击统一弹出 APP 详情提示。 */
export const AppDetailClickable: React.FC<AppDetailClickableProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={`message-card-clickable${className ? ` ${className}` : ''}`}
      role="button"
      tabIndex={0}
      onClick={showAppDetailTip}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          showAppDetailTip();
        }
      }}
    >
      {children}
    </div>
  );
};
